"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _CampaignTrackingParameterService = _interopRequireDefault(require("./CampaignTrackingParameterService"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _CampaignTrackingParameterService["default"];
exports["default"] = _default;